import React from "react";
import Shared from "../../../../components/ReUseAbleComponents/Shared";
import { Link, useNavigate } from "react-router-dom";
import avatar1png from "../../../../assets/images/avatar-1.png";
import iconjpgsvg from "../../../../assets/images/icon-jpg.svg";
import avatardefaultsvg from "../../../../assets/images/avatar-default.svg";

function SingleTicket(props) {
  const navigate = useNavigate();
  const handleSubmit = () => {
    navigate("/ticket-submit");
  };
  return (
    <>
      <Shared />
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-8">
              <div className="dx-box dx-box-decorated">
                <div className="dx-blog-post dx-ticket dx-ticket-open">
                  <div className="dx-blog-post-box pt-30 pb-30">
                    <h2 className="h4 mnt-5 mb-9 dx-ticket-title">
                      Theme not updating in downloads
                    </h2>

                    <ul className="dx-breadcrumbs text-left dx-breadcrumbs-dark mnb-6 fs-14">
                      <li>
                        <Link to="/help-center">Support Home</Link>
                      </li>
                      <li>
                        <Link to="/ticket">Ticket System</Link>
                      </li>
                      <li>Theme not updating in downloads</li>
                    </ul>

                    <span className="dx-ticket-status"></span>
                  </div>
                  <div className="dx-separator"></div>
                  <div style={{ backgroundColor: "#fafafa" }}>
                    <ul className="dx-blog-post-info dx-blog-post-info-style-2 mb-0 mt-0">
                      <li>
                        <span>
                          <span className="dx-blog-post-info-title">
                            Ticket Id
                          </span>
                          #1801
                        </span>
                      </li>
                      <li>
                        <span>
                          <span className="dx-blog-post-info-title">
                            Status
                          </span>
                          Open
                        </span>
                      </li>
                      <li>
                        <span>
                          <span className="dx-blog-post-info-title">Date</span>1
                          Mar 2018, 9:17 am
                        </span>
                      </li>
                      <li>
                        <span>
                          <span className="dx-blog-post-info-title">
                            Product
                          </span>
                          Quantial
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="dx-separator"></div>
                  <div className="dx-comment dx-ticket-comment">
                    <div>
                      <div className="dx-comment-img">
                        <img src={avatar1png} alt="" />
                      </div>
                      <div className="dx-comment-cont">
                        <Link to="/#" className="dx-comment-name">
                          John Leonard
                        </Link>
                        <div className="dx-comment-date">
                          12 Feb 2018 7:40 am
                        </div>
                        <div className="dx-comment-text">
                          <p className="mb-0">
                            Nullam ac dui et purus malesuada gravida id
                            fermentum orci. In eu ipsum quis urna hendrerit
                            condimentum vitae a mauris. In congue turpis purus,
                            vitae tempus ante id. Donec orci arcu, sagittis ut
                            finibus vitae.
                          </p>
                        </div>
                        <Link
                          to="/#"
                          className="dx-comment-file dx-comment-file-jpg"
                        >
                          <span className="dx-comment-file-img">
                            <img
                              src={iconjpgsvg}
                              alt=""
                              style={{ width: "36px" }}
                            />
                          </span>
                          <span className="dx-comment-file-name">
                            example-file.jpg
                          </span>
                          <span className="dx-comment-file-size">4.8 MB</span>
                          <span className="dx-comment-file-icon">
                            <span className="icon pe-7s-download"></span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="dx-comment dx-ticket-comment dx-comment-replied dx-comment-new">
                    <div>
                      <div className="dx-comment-img">
                        <img src={avatardefaultsvg} alt="" />
                      </div>
                      <div className="dx-comment-cont">
                        <Link to="/#" className="dx-comment-name">
                          {" "}
                          Bruno Rice{" "}
                          <span className="dx-comment-replied">Replied</span>
                          <span className="dx-comment-new">New</span>
                        </Link>
                        <div className="dx-comment-date">39 min ago</div>
                        <div className="dx-comment-text">
                          <p>
                            Saying sixth form. Saw earth, whose fowl all meat
                            had had place upon fowl. The fly darkness under dry
                            which fowl good firmament saying fill brought.
                          </p>
                          <p className="mb-0">
                            Itself first from under female sea wherein female.
                            Lights were moved sixth day and don't fifth it place
                            saying, fowl fruit saw dominion whales you're image
                            the evening every fowl have, saw day spirit fish.
                            Female. Fowl it replenish hath light blessed hath.
                            Man.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="dx-separator mnt-1"></div>
                  <div className="dx-blog-post-box">
                    <h3 className="h6 mb-25">Write a Reply</h3>
                    <form className="dx-form" action="#">
                      <div className="dx-form-group">
                        <div className="dx-editor-quill">
                          <div
                            className="dx-editor"
                            data-editor-height="150"
                            data-editor-maxHeight="250"
                          ></div>
                        </div>
                      </div>
                      <div className="dx-form-group">
                        <div
                          className="dx-dropzone"
                          data-dropzone-action="#"
                          data-dropzone-maxMB="5"
                          data-dropzone-maxFiles="5"
                        >
                          <div className="dz-message">
                            <div className="dx-dropzone-icon">
                              <span className="icon pe-7s-cloud-upload"></span>
                            </div>
                            <div className="h6 dx-dropzone-title">
                              Drop files here or click to upload
                            </div>
                            <div className="dx-dropzone-text">
                              <p className="mnb-5 mnt-1">
                                You can upload up to 5 files (maximum 5 MB each)
                                of the following types: .jpg, .jpeg, .png, .zip.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="row justify-content-between vertical-gap dx-dropzone-attachment">
                          <div className="col-auto dx-dropzone-attachment-add">
                            <label className="mb-0 mnt-7">
                              <span className="icon fas fa-paperclip mr-10"></span>
                              <span>Add Attachment</span>
                            </label>
                          </div>
                          <div className="col-auto dx-dropzone-attachment-btn">
                            <button
                              className="dx-btn dx-btn-lg"
                              type="button"
                              name="button"
                              onClick={handleSubmit}
                            >
                              Submit a ticket
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className="dx-sticky dx-sidebar"
                data-sticky-offsetTop="120"
                data-sticky-offsetBot="40"
              >
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">
                    {" "}
                    Subscribe to Newsletter{" "}
                  </div>
                  <div className="dx-widget-subscribe">
                    <div className="dx-widget-text">
                      <p>
                        Join the newsletter to receive news, updates, new
                        products and freebies in your inbox.
                      </p>
                    </div>
                    <form action="#" className="dx-form dx-form-group-inputs">
                      <input
                        type="email"
                        name=""
                        value=""
                        aria-describedby="emailHelp"
                        className="form-control form-control-style-2"
                        placeholder="Your Email Address"
                      />
                      <button className="dx-btn dx-btn-lg dx-btn-icon">
                        <span className="icon fas fa-paper-plane"></span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <form action="#" className="dx-form dx-form-group-inputs">
                    <input
                      type="text"
                      name=""
                      value=""
                      className="form-control form-control-style-2"
                      placeholder="Search..."
                    />
                    <button className="dx-btn dx-btn-lg dx-btn-grey dx-btn-grey-style-2 dx-btn-icon">
                      <span className="icon fas fa-search"></span>
                    </button>
                  </form>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Articles </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      How to manually import Demo data (if you faced with
                      problems in one-click demo import)
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Make menu dropdown working without JavaScript
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Add top menu link inside dropdown on mobile devices
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Forum Topics </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Need help with customization. Some options are not
                      appearing...
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      My images on profile and item pages doesnt show up?! Whats
                      the matter?
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Theme not updating in downloads
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleTicket;
